import { render } from "./partner.vue?vue&type=template&id=70f2dad3&scoped=true&ts=true"
import script from "./partner.vue?vue&type=script&lang=ts"
export * from "./partner.vue?vue&type=script&lang=ts"

import "./partner.vue?vue&type=style&index=0&id=70f2dad3&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70f2dad3"]])

export default __exports__